import { useEffect, useCallback } from 'react'
import { useSyncNotifications } from '../hooks/useSyncNotifications'
import Toast from './Toast'
import { useSyncStatus } from '../hooks/useSyncStatus'

export function SyncNotification() {
  const { discardedItems, dismiss } = useSyncNotifications()
  const { setShowSyncDetails } = useSyncStatus()

  // Auto-dismiss after 5 seconds
  useEffect(() => {
    if (discardedItems.length === 0) return

    const timers = discardedItems.map(item => 
      setTimeout(() => dismiss(item.id), 5000)
    )

    return () => timers.forEach(clearTimeout)
  }, [discardedItems, dismiss])

  const handleViewDetails = useCallback(() => {
    setShowSyncDetails(true)
  }, [setShowSyncDetails])

  if (discardedItems.length === 0) return null

  // Show summary toast for multiple errors
  if (discardedItems.length > 1) {
    return (
      <Toast
        message={`Sync failed (${discardedItems.length} items)`}
        type="error"
        onClose={() => discardedItems.forEach(item => dismiss(item.id))}
        duration={5000}
        action={{
          label: 'View Details',
          onClick: handleViewDetails
        }}
      />
    )
  }

  // Show individual toast for single error
  const item = discardedItems[0]
  return (
    <Toast
      message="Sync failed"
      itemName={item.reason}
      type="error"
      onClose={() => dismiss(item.id)}
      duration={5000}
      action={{
        label: 'View Details',
        onClick: handleViewDetails
      }}
    />
  )
}
